import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SiteSettings {
  underConstructionEnabled: boolean;
  underConstructionMessage: string;
  isLoading: boolean;
}

const SETTING_KEYS = [
  "site_under_construction_enabled",
  "site_under_construction_message",
];

export function useSiteSettings(): SiteSettings {
  const { data, isLoading } = useQuery({
    queryKey: ["site-settings"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("app_settings")
        .select("setting_key, setting_value")
        .in("setting_key", SETTING_KEYS);

      if (error) throw error;

      const settingsMap: Record<string, string> = {};
      data?.forEach((item) => {
        settingsMap[item.setting_key] = item.setting_value;
      });

      return {
        underConstructionEnabled: settingsMap.site_under_construction_enabled === "true",
        underConstructionMessage: settingsMap.site_under_construction_message || 
          "Site em construção — poderá encontrar alguns erros nas páginas ou na escrita.",
      };
    },
    staleTime: 60 * 1000,
  });

  return {
    underConstructionEnabled: data?.underConstructionEnabled ?? false,
    underConstructionMessage: data?.underConstructionMessage ?? 
      "Site em construção — poderá encontrar alguns erros nas páginas ou na escrita.",
    isLoading,
  };
}
